<template>
  <div id="boostProfile" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader class="hide">
      </WebshopHeader>
      <div class="py4 px3">
        <div class="pt2"></div>
        <h4 class="darkblue bold">Boost profil</h4>
        <p class="gibson mediumgrey"></p>
        <div class="py3">
          <div class="p0">
            <div class="clearfix" v-if="insideLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div id="profil" class="hide">
              <div class="lg-col-5 md-col-6 sm-col-10 p0">
                <div class="highlights">
                  <div class="flex justify-between items-start p2">
                    <div class="flex justify-start items-start">
                      <img class="circle fit block" height="36" src="static/svg/h.svg" alt="">
                      <div class="pl1">
                        <p v-html="companyName" class="h6 gibson semi-bold darkblue line-height-1 m0"></p>
                        <p class="h6 gibson mediumgrey light line-height-1 m0 p0" style="font-size:80%">
                          Sponsored
                        </p>
                      </div>
                    </div>
                    <div><i class="el-icon-more"></i></div>
                  </div>
                  <div class="px2">
                    <p class="h6 regular gibson darkblue line-height-3 mt1" style="font-size:90%">
                      Besøg vores profil på
                    </p>
                    <p class="h6 regular gibson darkblue line-height-3 mt1" style="font-size:90%">
                      <a :href="companyUrl" target="_blank" style="overflow-wrap: break-word;">
                        {{companyUrl}}
                      </a>
                    </p>
                  </div>
                  <div class="mt2 col-12 px0">
                    <img class="fit block col-12" :src="image" alt="" rel="preload" @load="imageLoaded()">
                  </div>
                  <div class="px2 pt1 pb2 lightgrey-background">
                    <p class="h6 semi-bold gibson darkblue line-height-1 mt1 p0" style="font-size:90%" v-html="companyName"></p>
                    <p class="hide mediumgrey regular line-height-1 m0 p0" style="margin-top:8px;margin-bottom:6px;font-size:75%" v-html="companyName">
                    </p>
                  </div>
                </div>
                <div>
                  <div class="pb2"></div>
                  <b-form-input id="amount" placeholder="Beløb her" class="mb1" @input="formatAmount()"></b-form-input>
                  <b-button type="button" class="action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" @click="confirmBoost('facebook')">Boost på facebook <i class="fab fa-facebook-f"></i>
                  </b-button>
                  <b-button type="button" class="action-button  py2 px3 m0 gibson not-rounded border-none regular col-12" @click="confirmBoost('google')">Boost på google  <i class="fab fa-google"></i>
                  </b-button>
                </div>
              </div>
              <!-- Boost confirmation modal -->
              <b-modal id="boost-modal" v-model="modalBoostConfirmation" hide-footer centered no-close-on-esc no-close-on-backdrop>
                <div class="center col-10 py3 mx-auto">
                  <div class="mb3">
                    <img src="static/svg/question-mark-new.svg" rel="preload" width="25%">
                  </div>
                  <div class="clearfix">
                    <p class="darkblue bold m0">Du er ved at booste din profil på <span class="capitalize">{{boostOption}}</span>.</p>
                    <p class="darkblue bold mb3">Ønsker du at forsætte?</p>
                    <div class="flex justify-between">
                      <b-button type="button" class="primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5" @click="modalBoostConfirmation = false">
                        Nej 
                      </b-button>
                      <b-button type="button" class="action-button  py2 px3 m0 gibson not-rounded border-none regular col-5" @click="boostProfile(boostOption)">
                        Ja
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-modal>
              <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import Simplert from 'vue2-simplert'
export default {
  name: '',
  components: {
    WebshopHeader,
    Simplert
  },
  data () {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      comanyName: '',
      image: '',
      description: '',
      boostOption: '',
      companyUrl: '',
      modalBoostConfirmation: false
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.companyName = localStorage.getItem('CompanyName')
    this.showProfileImage()
    this.setDefaultAmount()
  },
  methods: {
    setDefaultAmount () {
      setTimeout(function () {
        document.getElementById('amount').value = '200,00'
      }, 500)
    },
    addHide () {
      document.getElementById('profil').classList.add('hide')
    },
    removeHide () {
      document.getElementById('profil').classList.remove('hide')
    },
    imageLoaded () {
      this.removeHide()
      this.insideLoading = false
    },
    disableBoost () {
      document.getElementById('fbBoost').attr('disabled', 'disabled')
      document.getElementById('googleBoost').attr('disabled', 'disabled')
    },
    formatAmount () {
      setTimeout(function () {
        var amount = document.getElementById('amount').value
        if (amount !== '') {
          if (Number.isInteger(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            })
            document.getElementById('amount').value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '')
          } else {
            document.getElementById('amount').value = ''
          }
        }
      }, 1000)
    },
    confirmBoost (option) {
      this.boostOption = option
      this.modalBoostConfirmation = true
    },
    boostProfile (option) {
      const amount = document.getElementById('amount').value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
      if (amount !== '') {
        if (Number.isInteger(parseInt(amount))) {
          var url = ''
          if (option === 'facebook') {
            url = 'integration/PostPageToFBAd/' + this.haaId + '/' + amount
          } else {
            url = 'integration/PostProfileToGoogleAd/' + amount + '/' + this.haaId
          }
          // Post Ad
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          }
          this.$http.post('', data, { emulateJSON: true }).then(
            (response) => {
              var res = response.body
              if (res !== null) {
                if (res.success) {
                  // var adId = ''
                  // var adGroupId = ''
                  // if (option === 'facebook') {
                  //   adId = res.AdID
                  // } else {
                  //   adId = res.Result.AdId
                  //   adGroupId = res.Result.AdGroupId
                  // }
                  // // Pause ad
                  // this.stopStartAd(adId, adGroupId, option)
                  this.insideLoading = false
                  this.removeHide()
                  this.setDefaultAmount()
                  let obj = {
                    title: 'Dit profil boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  }
                  this.$refs.simplert.openSimplert(obj)
                } else {
                  this.insideLoading = false
                  this.removeHide()
                  this.setDefaultAmount()
                  this.$toastr('error', 'Fejl')
                  console.log('Error in boostProfile()', response)
                }
              } else {
                this.insideLoading = false
                this.removeHide()
                this.setDefaultAmount()
                this.$toastr('error', 'Allerede boostet')
                console.log('Error in boostProfile()', response)
              }
            },
            (response) => {
              this.insideLoading = false
              this.removeHide()
              this.setDefaultAmount()
              this.$toastr('error', 'Fejl')
              console.log('Error in boostProfile()', response)
            }
          )
          this.modalBoostConfirmation = false
          this.insideLoading = true
          this.addHide()
        } else {
          this.$toastr('error', 'Ugyldigt beløb')
        }
      } else {
        this.$toastr('error', 'Indtast beløb')
      }
    },
    // validatePayment (adId, orderId, amount, option) {
    //   var data = {
    //     createinvoice: true,
    //     orderid: orderId,
    //     price: amount
    //   }
    //   this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + adId, data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       // If paid
    //       if (res.result.paid) {
    //         console.log(res)
    //         this.insideLoading = false
    //         this.$toastr('success', 'Gennemført')
    //       } else {
    //         // If not
    //         this.stopStartAd(adId, option)
    //       }
    //     },
    //     (response) => {
    //       console.log('Error in validatePayment')
    //       this.insideLoading = false
    //     }
    //   )
    // },
    // stopStartAd (adId, adGroupId, option) {
    //   var url = ''
    //   if (option === 'facebook') {
    //     url = 'integration/PauseFbAd/' + adId
    //   } else {
    //     url = 'integration/PauseGoogleAd/' + adId + '/' + adGroupId
    //   }
    //   var data = {
    //     operation: 'bitrixApi',
    //     salesPerson: this.salesPerson,
    //     type: 'POST',
    //     url: url
    //   }
    //   this.$http.post('', data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       if (res.success) {
    //         this.insideLoading = false
    //         this.removeHide()
    //         this.setDefaultAmount()
    //         this.$toastr('success', 'Gennemført')
    //       } else {
    //         this.insideLoading = false
    //         this.removeHide()
    //         this.setDefaultAmount()
    //         this.$toastr('error', 'Fejl')
    //         console.log('Error in stopStartAd()', response)
    //       }
    //     },
    //     (response) => {
    //       this.insideLoading = false
    //       this.removeHide()
    //       this.setDefaultAmount()
    //       this.$toastr('error', 'Fejl')
    //       console.log('Error in stopStartAd()', response)
    //     }
    //   )
    // },
    showProfileImage () {
      var dataPartner = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.data
            this.image = res.resultImages[0].FileLocation
            this.description = res.Description
            this.companyUrl = res.url
          },
          response => {
            this.$toastr('error', 'Fejl')
            console.log('Error in showProfileImage()', response)
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// BoostProfilside.vue?cc938b72